// import Box from "@mui/material/Box";
// import React, { useState } from "react";
// const YouTubeEmbed = ({ videoId, isShort }) => {
//   const [showVideo, setShowVideo] = useState(false);

//   const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;

//   const handleClick = () => {
//     setShowVideo(true);
//   };

//   return (
//     <Box
//       onClick={handleClick}
//       sx={{
//         position: "relative",
//         cursor: "pointer",
//         width: { xs: "300px", md: "560px" },
//         height: { xs: "200", md: "315px" },
//         margin: "0 auto",
//       }}
//     >
//       {" "}
//       {!showVideo ? (
//         <>
//           <img
//             src={thumbnailUrl}
//             alt="YouTube video thumbnail"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//             }}
//           />
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               width: "68px",
//               height: "48px",
//               backgroundColor: "rgba(0,0,0,0.7)",
//               borderRadius: "14px",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <div
//               style={{
//                 width: "0",
//                 height: "0",
//                 borderStyle: "solid",
//                 borderWidth: "10px 0 10px 20px",
//                 borderColor: "transparent transparent transparent #fff",
//               }}
//             />
//           </div>
//         </>
//       ) : (
//         <iframe
//           width="100%"
//           height="100%"
//           src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//           allowFullScreen
//         ></iframe>
//       )}
//     </Box>
//   );
// };

// export default YouTubeEmbed;

import Box from "@mui/material/Box";
import React, { useState } from "react";

const YouTubeEmbed = ({ videoId, isShort }) => {
  const [showVideo, setShowVideo] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;

  const handleClick = () => {
    setShowVideo(true);
  };

  // Define aspect ratio based on isShort flag
  const aspectRatio = isShort ? "9 / 16" : "16 / 9";
  const width = isShort
    ? { xs: "149px", md: "210px" }
    : { xs: "300px", md: "560px" };
  const height = isShort
    ? { xs: "100px", md: "360px" }
    : { xs: "169px", md: "315px" };

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: "relative",
        cursor: "pointer",
        width: width,
        height: height,
        margin: "0 auto",
        aspectRatio: aspectRatio,
      }}
    >
      {!showVideo ? (
        <>
          <img
            src={thumbnailUrl}
            alt="YouTube video thumbnail"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          {/* Play button styles remain unchanged */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "68px",
              height: "48px",
              backgroundColor: "rgba(0,0,0,0.7)",
              borderRadius: "14px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "0",
                height: "0",
                borderStyle: "solid",
                borderWidth: "10px 0 10px 20px",
                borderColor: "transparent transparent transparent #fff",
              }}
            />
          </div>
        </>
      ) : (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1${
            isShort ? "&loop=1&playlist=" + videoId : ""
          }`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
    </Box>
  );
};

export default YouTubeEmbed;
